import {
  fetchV1Stocks,
  searchV1Stocks,
  fetchV1StockTransactions,
} from "@/services/v1/inventoryAPIService";

export default {
  state: {
    stocks: [],
    stockPageSize: 5,
    totalStockCount: 0,
    stockSearchQuery: "",
    stockMovements: [],
    stockMovementPageSize: 5,
    totalStockMovementCount: 0,
  },
  getters: {
    stocks: (state) => state.stocks,
    currentStockPageSize: (state) => state.stockPageSize,
    totalStockCount: (state) => state.totalStockCount,
    stockSearchQuery: (state) => state.stockSearchQuery,
    stockMovements: (state) => state.stockMovements,
    currentSTockMovementPageSize: (state) => state.stockMovementPageSize,
    totalStockMovementCount: (state) => state.totalStockMovementCount,
  },
  mutations: {
    SET_STOCKS(state, stocks) {
      state.stocks = stocks;
    },
    SET_STOCK_PAGE_SIZE(state, pageSize) {
      state.stockPageSize = pageSize;
    },
    SET_TOTAL_STOCKS_COUNT(state, count) {
      state.totalStockCount = count;
    },
    SET_STOCK_SEARCH_QUERY(state, query) {
      state.stockSearchQuery = query;
    },
    SET_STOCK_MOVEMENTS(state, stockMovements) {
      state.stockMovements = stockMovements;
    },
    SET_STOCK_MOVEMENT_PAGE_SIZE(state, pageSize) {
      state.stockMovementPageSize = pageSize;
    },
    SET_TOTAL_STOCK_MOVEMENTS_COUNT(state, count) {
      state.totalStockMovementCount = count;
    },
  },
  actions: {
    async fetchStocks(
      { commit },
      { page = 1, pageSize = 5, category = null } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Stocks(page, pageSize, category);
        commit("SET_STOCKS", response.results);
        commit("SET_STOCK_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_STOCKS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching stocks:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async searchStocks({ commit }, { query, page = 1, pageSize = 8 } = {}) {
      commit("SET_STOCK_SEARCH_QUERY", query);
      try {
        const response = await searchV1Stocks(query, page, pageSize);
        commit("SET_STOCKS", response.results);
        commit("SET_STOCK_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_STOCKS_COUNT", response.count);
      } catch (error) {
        console.error("Error searching stocks:", error);
      }
    },
    async fetchStockMovements({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1StockTransactions(page, pageSize);
        commit("SET_STOCK_MOVEMENTS", response.results);
        commit("SET_STOCK_MOVEMENT_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_STOCK_MOVEMENTS_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching movements:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
  },
};
